export const modalContentData: ModalContentData = {
  aa: {
    modalTitle: 'You’re Getting a 30% Referral Discount!',
    modalContent:
      'Your real estate goals and big savings are only clicks away. Select any Aceable real estate course, head to checkout, and your 30% discount will be auto-applied.',
    modalCTA: 'Select Course',
    ambassadorCampaign: '33113',
    // Halloween sale copy. Inert after `end`; remove with EPS-4976.
    saleOverride: {
      start: '2026-10-27T00:00:00-05:00',
      end: '2026-11-03T00:00:00-06:00',
      modalTitle: 'You’re Getting an Extra 10% Off!',
      modalContent:
        'Our Halloween sale is on, and your referral link gets you an extra 10% off on top of sale pricing. Select any Aceable real estate course, head to checkout, and your discount will be auto-applied.',
    },
  },
  ins: {
    modalTitle: 'You’re Getting a 30% Referral Discount!',
    modalContent:
      'Your new career and big savings are only clicks away. Select any Aceable insurance course, head to checkout, and your 30% discount will be auto-applied.',
    modalCTA: 'Select Course',
    ambassadorCampaign: '73551',
  },
  mtg: {
    modalTitle: 'You’re Getting a 30% Referral Discount!',
    modalContent:
      'Your new career and big savings are only clicks away. Select any Aceable Mortgage course, head to checkout, and your 30% discount will be auto-applied.',
    modalCTA: 'Select Course',
    ambassadorCampaign: '73550',
  },
  hsp: {
    modalTitle: 'You’re Getting a 30% Referral Discount!',
    modalContent:
      'Your new career and big savings are only clicks away. Select any Aceable Hospitality course, head to checkout, and your 30% discount will be auto-applied.',
    modalCTA: 'Select Course',
    ambassadorCampaign: '94967',
  },
};

interface ModalContentData {
  [key: string]: ModalContent;
}

export interface ModalContent {
  modalTitle: string;
  modalContent: string;
  modalCTA: string;
  ambassadorCampaign: string;
  saleOverride?: SaleOverride;
}

/** Copy shown instead of the default while now is within [start, end). */
interface SaleOverride {
  start: string;
  end: string;
  modalTitle: string;
  modalContent: string;
}
